import React from 'react';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { useTranslation } from 'react-i18next';
import { X, Minus, Maximize2, Bot, Users, Trash2 } from 'lucide-react';
import classNames from 'classnames';

/**
 * Componente para el header del chat
 * @param {Object} props - Propiedades del componente
 * @param {string} props.mode - Modo actual del chat
 * @param {Function} props.onClose - Callback para cerrar
 * @param {Function} props.onMinimize - Callback para minimizar
 * @param {Function} props.onClearChat - Callback para limpiar chat
 * @param {boolean} props.minimized - Si está minimizado
 */
const ChatHeader = ({
  mode,
  onClose,
  onMinimize,
  onClearChat,
  minimized = false
}) => {
  const { t } = useTranslation();

  // Obtener título del chat
  const getChatTitle = () => {
    return mode === 'ia' ? t('chat.asistente_ia') : t('chat.chat_interno');
  };

  // Obtener icono del modo
  const getModeIcon = () => {
    return mode === 'ia' ? <Bot size={16} /> : <Users size={16} />;
  };

  // Manejar limpiar chat con confirmación elegante
  const handleClearChat = () => {
    confirmDialog({
      message: t('chat.confirm_clear_chat'),
      header: t('chat.clear_chat_title'),
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-danger',
      accept: () => {
        onClearChat();
      },
      reject: () => {
        // No hacer nada si se cancela
      },
      acceptLabel: t('botones.confirmar'),
      rejectLabel: t('botones.cancelar')
    });
  };

  
  const headerClasses = classNames('chat-header', {
    'chat-header--minimized': minimized,
    [`chat-header--${mode}`]: mode
  });

  return (
    <div className={headerClasses}>
      {/* Título y estado */}
      <div className="chat-header-info">
        <div className="chat-header-title">
          <div className="chat-mode-icon">
            {getModeIcon()}
          </div>
          <div className="chat-title-text">
            <span className="chat-title">{getChatTitle()}</span>
          </div>
        </div>
      </div>

      {/* Controles */}
      <div className="chat-header-controls">
        <div className="chat-header-buttons">
          {/* Botón limpiar chat - solo visible cuando no está minimizado */}
          {!minimized && (
            <Button
              icon={<Trash2 size={16} />}
              className="chat-header-button chat-clear-button"
              onClick={handleClearChat}
              tooltip={t('chat.clear_chat')}
              tooltipOptions={{ position: 'bottom' }}
            />
          )}

          {/* Botón minimizar/expandir */}
          <Button
            icon={minimized ? <Maximize2 size={16} /> : <Minus size={16} />}
            className="chat-header-button chat-minimize-button"
            onClick={onMinimize}
            tooltipOptions={{ position: 'bottom' }}
          />

          {/* Botón cerrar */}
          <Button
            icon={<X size={16} />}
            className="chat-header-button chat-close-button"
            onClick={onClose}
            tooltipOptions={{ position: 'bottom' }}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
